import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArmyRegiment } from "../../../../lib/types";
import { portraits } from "../../../../assets/images/races";
import { DragescentState } from "../../../../store/reducers/stateType";
import { addBannerUnits, removeBannerUnits } from "../../../../store/actions";

interface IProps {
  regiment?: ArmyRegiment;
  own?: boolean;
  position: any;
  target: string;
  tactics: number;
  bannerUnits: number;
}

interface IAddUnitsLineProps {
  amount: number;
  bannerUnits: number;
  unitType: string;
  position: any;
  target: string;
  tactics: number;
}

const AddUnitLine = ({
  amount,
  bannerUnits,
  unitType,
  position,
  target,
  tactics,
}: IAddUnitsLineProps) => {
  const id = useSelector((state: DragescentState) => state.governorate.id);
  const army = useSelector((state: DragescentState) => state.governorate.army);
  const battleTactics = useSelector((state: DragescentState) => state.governorate.battleTactics);
  const armyCapacityUsage = useSelector(
    (state: DragescentState) => state.governorate.armyCapacityUsage
  );
  const dispatch = useDispatch();

  const [isBannerFull, setIsBannerFull] = useState(battleTactics[tactics][position] <= bannerUnits);
  const [
    isBannerFullFive,
    setIsBannerFullFive
  ] = useState(battleTactics[tactics][position] - bannerUnits < 5);
  const [canAssignUnit, setCanAssignUnit] = useState(
    amount < armyCapacityUsage.regimentUnitsLimit
  );

  useEffect(() => {
    setIsBannerFull(battleTactics[tactics][position] <= bannerUnits);
    setIsBannerFullFive(battleTactics[tactics][position] - bannerUnits < 5);
  }, [bannerUnits]);

  useEffect(() => {
    setCanAssignUnit(amount < armyCapacityUsage.regimentUnitsLimit);
  }, [amount, armyCapacityUsage.assignedUnits]);

  const onAddUnit = (units: number) => {
    dispatch(addBannerUnits(id, position, tactics, target, unitType, units));
  }

  const onRemoveUnit = (units: number) => {
    dispatch(removeBannerUnits(id, position, unitType, units));
  }

  return <>
    <div className="row">
      <div className={`col-md-5 col-xs-4 text-right no-padding-left ${amount ? "positive" : ""}`}>
        1
        <a
          className={`icon-minus icon align-sub ${amount ? "positive" : "disabled"}`}
          onClick={() => amount && onRemoveUnit(1)}
        />
      </div>
      <div className="col-md-2 col-xs-4 text-center no-padding-right no-padding-left">
        {amount}
      </div>
      <div
        className={`col-md-5 col-xs-4 text-left no-padding-right ${army[unitType].free > 0
        && !isBannerFull && canAssignUnit ? "positive" : ""}`}>
        <a
          className={`icon-plus icon align-sub ${army[unitType].free > 0 && !isBannerFull
            && canAssignUnit ? "positive" : "disabled"}`}
          onClick={() => army[unitType].free > 0 && !isBannerFull && onAddUnit(1)}
        />
        1
      </div>
    </div>
    <div className="row">
      <div className={`col-md-5 col-xs-4 text-right no-padding-left ${amount > 4 ? "positive" : ""}`}>
        5
        <a
          className={`icon-minus icon align-sub ${amount > 4 ? "positive" : "disabled"}`}
          onClick={() => amount > 4 && onRemoveUnit(5)}
        />
      </div>
      <div className="col-md-2 col-xs-4 text-center no-padding-right no-padding-left">&nbsp;</div>
      <div
        className={`col-md-5 col-xs-4 text-left no-padding-right ${army[unitType].free > 4
        && !isBannerFullFive && canAssignUnit ? "positive" : ""}`}>
        <a
          className={`icon-plus icon align-sub ${army[unitType].free > 4 && !isBannerFullFive
            && canAssignUnit ? "positive" : "disabled"}`}
          onClick={() => army[unitType].free > 4
            && !isBannerFullFive && onAddUnit(5)}
        />
        5
      </div>
    </div>
  </>
}

const ArmyRegimentPerson = ({
  regiment,
  own,
  position,
  target,
  tactics,
  bannerUnits
}: IProps) => {
  const name = useSelector((state: DragescentState) => state.governorate.name);
  const race = useSelector((state: DragescentState) => state.governorate.race);
  const unitNames = useSelector((state: DragescentState) => state.governorate.unitNames);
  const armyCapacityUsage = useSelector(
    (state: DragescentState) => state.governorate.armyCapacityUsage
  );

  const isRegimentAvailableToAdd = () => own && (regiment
    || armyCapacityUsage.activeRegiments < armyCapacityUsage.regimentsLimit);

  return (
    <>
      <span>
        <img width={37} height={37} src={portraits[(regiment?.governy.race || race).name]} alt={"Race portrait"}/>
      </span>
      <h3 className={`name ${(regiment?.governy.race || race).name}`}>{ regiment?.governy.name || name }</h3>
      <div>
        <span>{unitNames[(regiment?.governy.race || race).id].e1}</span>{isRegimentAvailableToAdd()
          ? <AddUnitLine
          amount={regiment?.units.E1?.amount || 0}
          unitType={"E1"}
          position={position}
          target={target}
          tactics={tactics}
          bannerUnits={bannerUnits}
        />
          : `: ${regiment?.units.E1?.amount || 0}`}
      </div>
      <div>
        <span>{unitNames[(regiment?.governy.race || race).id].e2}</span>{isRegimentAvailableToAdd()
          ? <AddUnitLine
          amount={regiment?.units.E2?.amount || 0}
          unitType={"E2"}
          position={position}
          target={target}
          tactics={tactics}
          bannerUnits={bannerUnits}
        />
          : `: ${regiment?.units.E2?.amount || 0}`}
      </div>
      <div>
        <span>{unitNames[(regiment?.governy.race || race).id].e3}</span>{isRegimentAvailableToAdd()
          ? <AddUnitLine
          amount={regiment?.units.E3?.amount || 0}
          unitType={"E3"}
          position={position}
          target={target}
          tactics={tactics}
          bannerUnits={bannerUnits}
        />
          : `: ${regiment?.units.E3?.amount || 0}`}
      </div>
    </>
  )
}

export default ArmyRegimentPerson;
